import { Dictionary } from '@shared/dictionary';

import { MeetingStatus } from '../enums';


export const getMeetingStatusLabel = (dictionary: Dictionary, value: Meetings.MeetingStatus) => {

  const MAP = {
    [MeetingStatus.Preparing]: dictionary.forms.meeting.meetingStatusPreparing,
    [MeetingStatus.Ready]: dictionary.forms.meeting.meetingStatusReady,
    [MeetingStatus.AwaitingReview]: dictionary.forms.meeting.meetingStatusAwaitingReview,
    [MeetingStatus.Completed]: dictionary.forms.meeting.meetingStatusCompleted,
  };
  return MAP[value];
};

export const getMeetingStatusColor = (value: Meetings.MeetingStatus) => {
  switch (value) {
  case MeetingStatus.Preparing:
    return 'secondary';
  case MeetingStatus.Ready:
    return 'success';
  case MeetingStatus.AwaitingReview:
    return 'info';
  case MeetingStatus.Completed:
  default:
    return 'default';
  }
};
